'use client';

import React from 'react';

interface PremiumGuardProps {
    children: React.ReactNode;
}

/**
 * PremiumGuard formerly handled Supabase authentication.
 * As part of the architectural cleanup, it now serves as a pass-through
 * while the new membership system is being evaluated.
 */
export const PremiumGuard: React.FC<PremiumGuardProps> = ({ children }) => {
    return <>{children}</>;
};
